import { KYMW1100Model } from './../kymw1100.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';


/**
 * 消費税区分、消費税率取得クラス
 *
 * @export GetConsumeTaxInfoService
 * @class GetConsumeTaxInfoService
 * @extends {PlessResponder}
 */
@Injectable()
export class GetConsumeTaxInfoService extends PlessJsonResponderSub<any> {
  // 処理に使用するModel
  private model: KYMW1100Model;
  vo: Array<any>;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetConsumeTaxInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        ClassCode: this.vo[0],
        ApplyTermStart: this.vo[1],
        SmallClassCode: this.vo[2]
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetConsumeTaxInfoService
   */
  execute(model: KYMW1100Model, vo: Array<any>, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getConsumeTaxInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetConsumeTaxInfoService
   */
  success(data: any): void {
    this.model.setConsumeTax(data);
    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
